const input = {
  size: 25
};

export default input;
